import React from 'react';
import FormCard from '../components/FormCard/FormCard';
import { Form, Button, Row, Col } from 'react-bootstrap';
import UploadImage from '../../client/components/ImageUpload';
import { useSelector } from 'react-redux';
import { useState, useEffect } from 'react';
import axios from 'axios';

export default function Profile() {
    const [seller_profile_name, setName] = useState('');
    const [seller_profile_email, setEmail] = useState('');
    const [seller_profile_number, setNumber] = useState();
    const [seller_profile_alternative_number, setAlternativeNumber] = useState();
    const [seller_profile_address, setAddress] = useState('');

    const {user}=useSelector((state)=> state.auth);
    const sellerId = user.seller_profile_id;

    useEffect(()=> {
        const getSeller = async(id)=> {
            await axios.get(process.env.REACT_APP_FIND_API_URL + `/seller/get/${id}`, {withCredentials: true}).then((res)=> {
                setName(res.data[0].seller_profile_name);
                setEmail(res.data[0].seller_profile_email);
                setAddress(res.data[0].seller_profile_address);
                setNumber(res.data[0].seller_profile_number);
                setAlternativeNumber(res.data[0].seller_profile_alternative_number);
            })
        }
        getSeller(sellerId);
    }, [sellerId]);

    const handleSubmit = async(e)=> {
        e.preventDefault();
        try {
            const res = await axios.patch(process.env.REACT_APP_FIND_API_URL + '/seller/update', 
                {
                    seller_profile_id: sellerId,
                    seller_profile_name,
                    seller_profile_email,
                    seller_profile_address,
                    seller_profile_number,
                    seller_profile_alternative_number
                }, {withCredentials: true})
            console.log(res.data);
        } catch (error) {
            console.log(error);
        }
    }
    return (
        <FormCard title="Update Your Profile">
            <Form onSubmit={handleSubmit}>
                <Row>
                    <Col md="6">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Name</Form.Label>
                            <Form.Control type="text" placeholder="Enter Name" value={seller_profile_name} onChange={(e) => setName(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control type="email" placeholder="Enter email" value={seller_profile_email} onChange={(e) => setEmail(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="12">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Address</Form.Label>
                            <Form.Control type="text" placeholder="Enter Address" value={seller_profile_address} onChange={(e) => setAddress(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control type="number" placeholder="Enter Phone Number" value={seller_profile_number} onChange={(e) => setNumber(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="6">
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Alternative Phone Number</Form.Label>
                            <Form.Control type="number" placeholder="Enter Phone Number" value={seller_profile_alternative_number} onChange={(e) => setAlternativeNumber(e.target.value)} />
                        </Form.Group>
                    </Col>
                    <Col md="12">
                        <UploadImage title="Image" />
                    </Col>
                </Row>
                <div>
                    <Button variant="primary" type="submit" className="w-100">
                        Submit
                    </Button>
                </div>
            </Form>
        </FormCard>
    )
}
